import '../../../common/css/base.scss';
import '../../../common/js/amap-debug'; // 此文件引用需要置顶，否则mock的时候会有问题
import Vue from 'vue';
import Vant from 'vant';

import amapApp from '@ali/amap-lib';
import Monitor from '@ali/act-monitor';
import {
  install as installMap,
  setConfig as setMapConfig
} from '@ali/amap-traffic-brain-fe-common-map';
import AES from '@ali/aes-tracker';
import AESPluginEvent from '@ali/aes-tracker-plugin-event';
import App from '../components/App.vue';
import ACTDATA from '../../../config/config.act';
import registerCustomLayers from '../components/jiaotonghao/mapLayer/index';
import '../css/mapLayers';
import '../../../common/css/vant';
import service from '../../../common/js/service';
import AesMonitor from '../../../common/js/monitor';

import '@ali/aes-tracker-plugin-pv';
import '@ali/aes-tracker-plugin-jserror';
import '@ali/aes-tracker-plugin-api';
import '@ali/aes-tracker-plugin-perf';
import '@ali/aes-tracker-plugin-eventTiming';
import '@ali/aes-tracker-plugin-animFluency';
import '@ali/aes-tracker-plugin-autolog';
import '@ali/aes-tracker-plugin-longtask';

const moment = require('moment');

// 引入地图组件
const MAP_KEY = '95ac9aa16fbaee22fe59b0df5b3a07e4';
const MAP_VERSION = '2.0';
setMapConfig({
  key: MAP_KEY,
  version: MAP_VERSION,
  isTest: false,
  plugins: [
    'AMap.GeoJSON',
    'AMap.PlaceSearch',
    'AMap.RangingTool',
    'AMap.MouseTool',
    'AMap.DistrictSearch',
    'AMap.CitySearch',
    'AMap.CircleEditor',
    'AMap.PolygonEditor',
    'AMap.PolylineEditor',
    'AMap.Geocoder',
    'AMap.Geolocation'
  ]
});
console.log(`是否公网环境${amapApp.webviewInfo.isPublic()}`);
Monitor.init({
  pid: '2019PushTemplate',
  ptype: amapApp.webviewInfo.isInAmap() ? 'amapH5' : 'webH5',
  isPublic: amapApp.webviewInfo.isPublic(),
  collectPerformance: true,
  version: 'csr'
});
// Monitor.log({ type: 'pageShow', id: amapApp.util.getUrlParam('id') });
Vue.config.productionTip = false;
Vue.config.devtools = !amapApp.webviewInfo.isPublic();

Vue.use(Vant);

Vue.prototype.$moment = moment;
// 修改客户端错误上报
(function () {
  if (!window.__mapview__rightbutton) {
    window.__mapview__rightbutton = () => {};
  }
  if (!window.activeEvent) {
    if (amapApp.os && amapApp.os.ios) {
      window.activeEvent = {};
    } else {
      window.activeEvent = () => {};
    }
  }
  if (!window.onNativeBackEvent) {
    window.onNativeBackEvent = () => {};
  }
}());
amapApp.bridge.ready(async (res) => {
  AesMonitor.setPublicCustomParams(res);
  // 埋点
  amapApp.log.initLog(`${ACTDATA.name}_index`, 1);
  new Vue({
    el: '#app',
    render: (h) => h(App),
    data: { appInfo: res },
  });
  Vue.config.errorHandler = (error, vm, msg) => {
    Monitor.error(error);
    AesMonitor.sendMonitorJSError(error);
    console.error(error, vm, msg);// 在控制台打出错误
  };

  // 禁用客户端回退逻辑
  amapApp.bridge.send({
    action: 'interceptNativeBackEvent',
    // eslint-disable-next-line no-bitwise
    backEvent: (1) | (2) | (4)
  });
  const startTime = new Date().getTime();
  let endTime = 0;
  let pagehideTime = 0; // 离开的时间和 所有visible-hidden
  let curPagehideTime = 0; // 离开的时间

  const isNewMessageBoxAvailable = await service.compareAppVersion('121000');
  const isPush = amapApp.util.getUrlParam('amsfrom') === 'push';
  const from = amapApp.util.getUrlParam('gd_from') || 'push';

  const isInAmap = amapApp.webviewInfo.isInAmap();
  const scheme = `amapuri://ajx?path=path://amap_bundle_messagebox/src/NewMessageBoxPage.page.js&from=${from}`;
  if (isInAmap) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') { // 展示
        pagehideTime += new Date().getTime() - curPagehideTime;
      } else { // 隐藏
        curPagehideTime = new Date().getTime();
      }
      console.log('pagehideTime: ', pagehideTime);
    });
  }
  window.onNativeBackEvent = () => {
    endTime = new Date().getTime();
    amapApp.log.log('stay_time', {
      duration: Math.floor((endTime - startTime - pagehideTime) / 1000),
      from: amapApp.util.getUrlParam('from') || '',
    });
    // 新版通知中心上线版本
    if (isInAmap && isPush && isNewMessageBoxAvailable) {
      // 跳转新通知中心
      amapApp.native.loadSchema(scheme);
    }
    // 直接退出活动
    amapApp.native.webviewGoBack();
  };
});
